<script>
import API from '@/http/merchant/submit'
// import relationAPI from '@/http/merchant/submit'
const qs = require('qs')

export default {
  data() {
    return {
      syncToken: '',
      syncAddress: '',
      dataGroupOrgId: '',
      ipPort: {
        ip: '82.156.248.190',
        port: '9649'
      },
      failed: {
        invoFailed: 0,
        annexFailed: 0
      },
      isChecked: {
        checkInvo: false,
        checkAnnex: false
      },
      address: '',
      PublishKey: '',
      header: {
        'Content-Type': 'multipart/form-data;charset=utf-8'
      }
    }
  },
  watch: {
    isChecked: {
      handler() {
        // 如果都检查完毕 则去判断失败数量
        if (this.isChecked.checkAnnex && this.isChecked.checkInvo) {
          // 检查失败数量是否为空
          this.checkFailedNumer()
        }
      },
      deep: true
    }
  },
  methods: {
    initFileMixins() {
      this.failed.invoFailed = 0
      this.failed.annexFailed = 0
      this.isChecked.checkInvo = false
      this.isChecked.checkAnnex = false
    },
    // 根据 域用户名获取token，如果失败则再次请求
    getToken(obj) {
      // this.$loading()
      return new Promise((resolve, reject) => {
        API.querySyncConfig(obj).then(res => {
          if (res.code === 200) {
            // 获取到token
            const data = res.data
            this.syncAddress = data.syncAddress
            this.syncToken = `Bearer ${data.syncToken}`
            this.address = data.syncTicketIdAddress
            this.PublishKey = data.publicKey
            // 根据信息下载图片流进行上传
            resolve()
          } else if (res.code !== 500) {
            this.getToken(obj)
          } else {
            this.severLoading.close()
            this.$alert(res.msg, '提示', {
              confirmButtonText: '确定',
              type: 'error'
            })
          }
        })
      })
    },

    // 获取发票ID
    getInvoiceId(file, item) {
       return new Promise((resolve, reject) => {
          const url = `${this.address}api/AddTempDocument`
          // 创建 FormData表单数据实例
          const fd = new FormData()
          // 添加图片文件
          fd.append('files', file)
          // 以下字段为固定字段数据
          fd.append('DocumentType', 1)
          fd.append('Source', '发票助手')
          fd.append('DocumentName', '发票助手')
          fd.append('PublishKey', this.PublishKey)
          item.progress = 35
          this.$axios({
            url,
            method: 'POST',
            data: fd,
            mode: 'cors',
            withCredentials: false,
            traditional: true,
            headers: this.header
          }).then(res => {
            const data = res.data
            if (data.success) {
              resolve(data)
            } else {
              this.alert(data.message)
            }
          })
         
       })
    },
    // 根据ID和其他参数上传发票
    submitInvoice(id, file, index, item) {
      return new Promise((resolve, reject) => {
        // 将图片转为base64格式
        this.fileToBase64(file, Base64Images => {
          const url = `${this.syncAddress}tgjswxInvoiceAssistant/api/InvoiceAssistant/BatchSaveToTicketHolder`
          const base64 = Base64Images.split('data:application/octet-stream;base64,')
          const data = {
            Base64Images: base64[1],
            Attachment: id, // 发票ID
            platform: 'FinanceShare' // 固定值
          }
          const headers = {
            Authorization: this.syncToken,
            'Content-Type': 'application/json'
          }
          this.$axios
            .post(url, data, {
              headers: headers
            })
            .then(res => {
              // 如果成功
              const data = res.data
              if (data.isValid) {
                let obj = {
                  data,
                  index
                }
                resolve(obj)
              } else {
                this.alert(data.message)
              }
            })
        })
      })
    },
    // 对发票文件集合进行循环转换base64后并上传
    filterInvoList() {
      let tag = 0      
      let flagCount = 0
      this.ticketImgsList.forEach((item, index) => {
        if(item.status!==1){ flagCount ++ }
      })
      this.ticketImgsList.forEach((item, index) => {
        if(item.status!==1){
          this.getInvoiceId(item.img, item).then(res => {
            if (res.data && res.data.length > 0) {
              item.Attachment = res.data[0]
              this.fileToBase64(item.img, Base64Images => {
                const base64 = Base64Images.split('data:application/octet-stream;base64,')
                item.Base64Images = base64[1]
                tag ++
                if (tag === flagCount) {
                  this.submitInvoiceList()
                }
              })
            } else {
              this.alert('发票失败，请稍后重试')
            }
          })
        }
        
      })
    },
    // 上传发票
    submitInvoiceList() {
      const url = `${this.syncAddress}api/InvoiceAssistant/BatchSaveToTicketHolder`
      const headers = {
        Authorization: this.syncToken,
        'Content-Type': 'application/json'
      }
      // 组装上传数据
      const obj = {
        'platform': 'FinanceShare', // 固定值
        'batchOcrTicketActionRequests': []
      }
      this.ticketImgsList.forEach(item => {
        obj.batchOcrTicketActionRequests.push({
          'Base64Images': item.Base64Images,
          'Attachment': item.Attachment
        })
      })
      // 进行上传
       this.$axios({
        url,
        method: 'POST',
        data: obj,
        headers
      })
      .then(res => {
        if (res.status === 200 && res.data) {
          // && res.data.data.length > 0
          if (res.data.isValid) {
            // 上传到服务器后对每张发票进行检查并格式化传入数据
            this.checkSubimtInvoList(res.data.imageSystemReturnResponses)
          } else {
            // 上传到服务器失败直接进行提示
            this.alert(res.data.errorMessages)
          }
        } else {
           this.alert('发票上传失败')
        }
      })
    },
    // 检查返回的发票列表是否有失败的
    checkSubimtInvoList(list) {
      // 失败数量
      let isValidNumer = 0
      list.forEach((item, index) => {
        if (item.isValid && item.data.length > 0) {
          this.item.settlementInvoiceList[index].result = item.data[0]
          const attachmentUrl = JSON.parse(item.data[0].attachmentUrl)[0]
          this.item.settlementInvoiceList[index].attachmentUrl = attachmentUrl
          this.item.settlementInvoiceList[index].status = 1
        } else {
          // 如有失败的对失败数量加一，进行判断
          isValidNumer ++
          this.item.settlementInvoiceList[index].errorMsg = item.errorMessages
          this.item.settlementInvoiceList[index].attachmentUrl = this.ticketImgsList[index].Attachment
          this.item.settlementInvoiceList[index].status = 2
        }
      })
      // 有失败的，则将失败数量赋值给全局字段，方便后面判断比对
      if (isValidNumer != 0) {
        this.failed.invoFailed = isValidNumer
      }
      // 设置检查状态为完成
      this.isChecked.checkInvo = true
    },
    // 上传结算单
    submitConfirme() {
      return new Promise((resolve, reject) => {
        const url = `${this.syncAddress}api/Annex/BatchSaveFile`
        const fd = new FormData()
        // 组装上传数据，多个文件上传
        this.annexImgsList.forEach(item => {
          fd.append('files', item.img)
        })
        // 固定值，不可修改
        fd.append('platform', 'FinanceShare')
        this.$axios({
          url,
          method: 'POST',
          data: fd,
          headers: {
            Authorization: this.syncToken,
            'Content-Type': 'application/json'
          }
        })
        .then(res => {
          resolve(res)
        })
      })
    },
    // 检查结算确认单是否有失败
    checkSubimtAnnex(list) {
      // 如有失败的则为false，同时打开弹框
      let isValidNumer = 0
      list.forEach((item, index) => {
        if (item.isValid) {
          this.item.settlementAnnexes[index].entityId = item.entityId
          this.item.settlementAnnexes[index].status = 1
        } else {
          isValidNumer ++
          this.item.settlementAnnexes[index].errorMsg = item.errorMessages
          this.item.settlementAnnexes[index].status = 2
        }
      })
      if (isValidNumer != 0) {
        this.failed.annexFailed = isValidNumer
      }
      this.isChecked.checkAnnex = true
    },
    // 检查失败数量 有一个不为零则显示弹框提示进行修改
    checkFailedNumer() {
      let tag = false
      let str = '共有 '
      if (this.failed.invoFailed!==0) {
        str += `<br />${this.failed.invoFailed}张发票上传失败，请更换发票图片或进行手动核验`
        tag = true
      }
      if (this.failed.annexFailed!==0) {
        str += `<br />${this.failed.annexFailed}张确认单 上传失败，请修改图片或稍后重试`
        tag = true
      }
      str += ''
      // 如果有失败的
      this.severLoading.close()
      if (tag) {
        this.$confirm(str, '提示', {
          confirmButtonText: '去修改',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: 'error'
        }).then(() => {
          this.dialogForm = this.deepCopy(this.item)
          this.dialogVisible = true
          API.updateData(this.item).then()
         
        }).catch(() => {
          // 关闭
        })
      } else {
        this.submitFn(this.item)
      }
    },
    // 将文件转为base64格式
    fileToBase64(file, fn) {
      let reader = new FileReader()
      reader.onload = e => {
        fn(reader.result)
      }
      reader.readAsDataURL(file)
    },
    // 将file转换成Url回显
    fileToUrl(file, fn) {
       let url = URL.createObjectURL(file.raw)
       return url
    },
    getImgFn(id) {
      return new Promise((resolve) => {
         this.$axios({
          method: 'get',
          url: `/prod-api/file/preViewImage/${id}`,
          responseType: 'blob',
          headers: {
            Authorization: 'Bearer ' + localStorage.TOKEN
          }
        }).then(res => {
          const dataInfo = res.data
          let content = res.headers['content-disposition'].split(';')
          let fileName = content[1].split('=')[1]
          let reader = new window.FileReader()
          reader.readAsArrayBuffer(dataInfo)
          reader.onload = e => {
            const result = e.target.result
            const contentType = dataInfo.type
            const blob = new Blob([result], { type: contentType })
            let file = new File([blob], fileName)
            resolve(file)
          }
        })
      })
    },
    alert(msg) {
      this.severLoading.close()
      this.$alert(msg, '提示', {
        confirmButtonText: '确定',
        type: 'error'
      })
    }
  }
}
</script>
